import { useInfiniteQuery } from '@tanstack/react-query';
import { getNotifications } from '../api/fetchers/notificationFetcher';

const useGetNotifications = ({ enabled = true } = {}) => {
    return useInfiniteQuery({
        queryKey: ['notifications'],
        queryFn: ({ pageParam = 1 }) => getNotifications(pageParam),
        getNextPageParam: (lastPage) => {
            const pagination = lastPage?.response_data;
            if (!pagination?.current_page || !pagination?.last_page) return undefined;
            return pagination.current_page < pagination.last_page
                ? pagination.current_page + 1
                : undefined;
        },
        enabled,
    });
};

export default useGetNotifications;
